import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function useYMHit(counterId = 103963567) {
  const location = useLocation();
  const first = useRef(false);

  useEffect(() => {
    // первый хит уже ушёл при init — пропустим дубль
    if (!first.current) { first.current = true; return; }
    if (window.ym) {
      window.ym(counterId, "hit", location.pathname + location.search, {
        referer: document.referrer || undefined,
        title: document.title || undefined,
      });
    }
  }, [location.pathname, location.search, counterId]);
}
